export const sliceArray = Array.prototype.slice;
